export const ProjectIconBackgroundColor = (color) => {
  const ProjectIconColor = {
    RED: '#FA4371',
    GREEN: '#0FB800',
    YELLOW: '#F9C306',
    BLUE: '#316BE8',
  }

  switch (color) {
    case ProjectIconColor.RED:
      return "#FFE6ED";
    case ProjectIconColor.GREEN:
      return "#DAFFD7";
    case ProjectIconColor.YELLOW:
      return "#FFF6D6";
    case ProjectIconColor.BLUE:
      return "#E1EBFF";
    default:
      return "#E1EBFF";
  }
};